module.exports = __webpack_public_path__ + "img/egame_sky.a8b46798.png";